const useRacing = () => {
	const convertJockeyWeight = (weight: string) => {
		if (!weight) return "";

		const stonePounds = weight.split(" ");
		let stone = 0;
		if (weight.includes("st")) {
			stone = +stonePounds[0].slice(0, stonePounds[0].length - 2);
		}
		let pounds = 0;
		if (weight.indexOf("lbs")) {
			pounds = +stonePounds[1].slice(0, stonePounds[1].length - 3);
		}

		const poundsValue = pounds / 14;
		const convertedWeight = ((parseFloat(stone.toString()) + parseFloat(poundsValue.toString())) * 6.35029318).toFixed(2);

		return Math.round(+convertedWeight * 2) / 2 + "kg";
	};

	const convertDistance = (distance: string) => {
		if (!distance || distance === "N/A") return "N/A";
		let furlong = 0 || "";
		let yards = 0 || "";
		let miles = 0 || "";
		const splitDistance = distance.split(" ");
		if (splitDistance && splitDistance.length > 0) {
			if (distance.includes("f")) {
				furlong = splitDistance[1].slice(0, splitDistance[1].length - 1);
			}
			if (distance.includes("y")) {
				yards = splitDistance[2].slice(0, splitDistance[2].length - 1);
			}
			if (distance.includes("m")) {
				miles = splitDistance[0].slice(0, splitDistance[0].length - 1);
			}
		}
		let distanceMeters = 0 || "";
		distanceMeters = (parseInt(furlong) * 201.168 + parseInt(yards) / 1.0936133 + parseInt(miles) * 1609.344).toFixed(2);
		// Round to the nearest 100
		return Math.round(Number(distanceMeters) / 100) * 100 + "m" || "N/A";
	};

	return {
		convertJockeyWeight,
		convertDistance,
	};
};
export default useRacing;
